import { KeyboardEvent, FormEvent } from 'react'

export const handleKeyDown =
  (onChange: (event: FormEvent<HTMLInputElement>) => void) => (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onChange(event as FormEvent<HTMLInputElement>)
    } else if (
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === ' '
    ) {
      event.preventDefault()
      return
    }
  }
